module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-21 at 12.22.14.16870168.png";